export default __webpack_public_path__ + "static/media/GMT.3787c7f2.svg";